import React, { Component } from "react";
import PropTypes from "prop-types";

import createMuiTheme from "material-ui/styles/createMuiTheme";
import { MuiThemeProvider } from "material-ui/styles";
import injectTapEventPlugin from "react-tap-event-plugin";
import AppContainer from "./AppContainer";

import indigo from "material-ui/colors/indigo";
import red from "material-ui/colors/red";
import "typeface-roboto";

injectTapEventPlugin();

const defaultTheme = createMuiTheme();

const theme = createMuiTheme({
  palette: {
    primary: {
      light: indigo[300],
      main: indigo[500],
      dark: indigo[700],
      contrastText: defaultTheme.palette.getContrastText(indigo[500]),
      ...indigo
    },
    secondary: {
      light: red.A200,
      main: red.A400,
      dark: red.A700,
      contrastText: defaultTheme.palette.getContrastText(red.A400),
      ...red
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
      icon: "rgba(0, 0, 0, 0.38)",
      divider: "rgba(0, 0, 0, 0.12)",
      lightDivider: "rgba(0, 0, 0, 0.075)"
    }
  }
});

class ThemedApp extends Component {
  componentDidMount() {
    this.props.updateGeometry(this.props.width);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.width !== this.props.width) {
      this.props.updateGeometry(nextProps.width);
    }
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <AppContainer />
      </MuiThemeProvider>
    );
  }
}

ThemedApp.propTypes = {
  width: PropTypes.string.isRequired,
  updateGeometry: PropTypes.func.isRequired
};

export default ThemedApp;



// WEBPACK FOOTER //
// ./src/ThemedApp.js